import React, { useEffect } from "react";
import { FlatList } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import {
  getCampaignTeamRankingRequest,
  loadCampaignTeamRankingRequest,
} from "@microdoing/shared/services/ranking/actions";
import { Box, Spinner } from "../../components/common";
import Header from "./Header.js";
import i18n from "@microdoing/shared/i18n";
import TeamRankingRow from "app/scenes/CurrentTrackScreen/TeamScreen/TeamRankingRow";
import theme from "app/Theme/Theme";
import WebDesktopView from "app/components/common/Web/WebDesktopView";
import { breadCrumbsTeamRankingScreen } from "app/navigation/breadcrumb/BreadcrumbPaths";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import {
  getCampaignId,
  getTeamId,
} from "@microdoing/shared/services/userCampaign/selectors";
import {
  getCampaignTeamRanking,
  getRankingHasResult,
  getRankingLoading,
  getRankingRequesting,
  getTeamRankingPage,
} from "@microdoing/shared/services/ranking/selectors";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import MainHeader from "app/components/common/MainHeader";

const RankingScreen = ({ navigation }) => {
  const dispatch = useDispatch();
  const campaignId = useSelector(getCampaignId);
  const requesting = useSelector(getRankingRequesting);
  const loading = useSelector(getRankingLoading);
  const hasResult = useSelector(getRankingHasResult);
  const campaignTeamRankingPage = useSelector(getTeamRankingPage);
  const campaignTeamRanking = useSelector(getCampaignTeamRanking);
  const teamId = useSelector(getTeamId);

  const insets = useSafeAreaInsets();

  useEffect(() => {
    dispatch(
      getCampaignTeamRankingRequest({
        page: 0,
        campaignId,
        limit: 10,
      }),
    );
  }, []);

  const keyExtractor = (item, index) => {
    return index.toString();
  };

  const loadMore = () => {
    if (!requesting && !loading && hasResult) {
      dispatch(
        loadCampaignTeamRankingRequest({
          page: campaignTeamRankingPage,
          campaignId,
          limit: 10,
        }),
      );
    }
  };

  const handleTeamPress = team => () => {
    navigation.navigate("TeamDetails", { team });
  };

  const renderRanking = data => {
    const { name, points, _id } = data.item;
    if (!_id) return null;

    const isMyTeam = _id === teamId;

    return (
      <TeamRankingRow
        {...data.item}
        onPress={handleTeamPress(data.item)}
        rank={data.index + 1}
        key={_id}
        teamName={name}
        points={points}
        isUserTeam={isMyTeam}
      />
    );
  };

  return (
    <WebDesktopView breadcrumbsPath={breadCrumbsTeamRankingScreen}>
      <Box
        flex={1}
        width="100%"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        backgroundColor="neutral.white"
        borderRadius={isWebDesktop ? 8 : 0}
        testID={"team-ranking-screen"}
        style={{ paddingTop: insets.top }}
      >
        {!isWebDesktop && <MainHeader title={i18n.t("team-ranking-title")} />}
        <Box flex={1} width="100%" flexDirection="row">
          <FlatList
            data={campaignTeamRanking}
            renderItem={renderRanking}
            keyExtractor={keyExtractor}
            keyboardShouldPersistTaps="always"
            ListHeaderComponent={requesting && <Spinner size={50} />}
            ListFooterComponent={loading && <Spinner size={50} />}
            onEndReached={loadMore}
            onEndThreshold={0}
          />
        </Box>
      </Box>
    </WebDesktopView>
  );
};

export default RankingScreen;
